import { DateTime, Zone } from 'luxon';

function convertToDateTime(date: string | number | Date | DateTime): DateTime | null {
  if (date instanceof Date && Number.isNaN(date.getTime())) {
    return DateTime.now();
  }
  
  if (typeof date === 'string') {
    return DateTime.fromISO(date);
  }
  
  if (typeof date === 'number') {
    return DateTime.fromMillis(date);
  }
  
  if (DateTime.isDateTime(date)) {
    return date;
  }
  
  if (date instanceof Date) {
    return DateTime.fromJSDate(date);
  }
  
  return null;
}

export function parseDateTime(
  date: string | number | Date | DateTime | null | undefined,
  timeZone?: string | Zone
): DateTime | null {
  if (!date) {
    return null;
  }

  const dateTime = convertToDateTime(date);
  
  if (!dateTime) {
    return null;
  }

  if (timeZone && dateTime.setZone(timeZone).isValid) {
    return dateTime.setZone(timeZone);
  }

  return dateTime;
}
